import styled from "styled-components"

const StyledSVG = styled.svg``

const SvgComponent = () => {
  const w = 48
  const h = 48
  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      data-name="McD_GoldenArches® Logo"
      width={w}
      height={h}
      viewBox="0 0 48 48"
      aria-labelledby="mcd-logo-title mcd-logo-desc"
      role="img"
    >
      <title id="mcd-logo-title">
        Link to the McDonalds Gift Card app home page
      </title>
      <desc id="mcd-logo-desc">
        Golden arches logo of McDonalds that is a link to the home page
      </desc>
      <rect width="48" height="48" rx="3.84" fill="#264F36" />
      <path
        d="M30.9993 9.60309C28.1728 9.60309 25.6497 13.4783 24.0005 19.5391C22.3493 13.4783 19.8261 9.60309 16.9996 9.60309C12.0301 9.60309 8 22.498 8 38.4031H12.0017C12.0017 23.633 14.2395 11.6596 16.9996 11.6596C19.7598 11.6596 21.9997 22.7124 21.9997 36.3466H26.0014C26.0014 22.7124 28.2402 11.6596 31.0014 11.6596C33.7626 11.6596 35.9983 23.633 35.9983 38.4031H40C39.9989 22.498 35.9688 9.60309 30.9993 9.60309Z"
        fill="#FFBC0D"
      />
    </StyledSVG>
  )
}

export default SvgComponent
